import { IUpdateBonusStatesResponseItem } from "../types";

export function getPostBonusStateErrors(
  response: IUpdateBonusStatesResponseItem[],
) {
  return response.reduce((acc: string[], item) => {
    if (item.updated) return acc;

    return [...acc, `id ${item.id + ": " + item.reasons.join("\r\n ")}`];
  }, []);
}
